





















































import { Component, Vue } from "vue-property-decorator";
import registryService from "@/services/registry.service";
import {
  BSpinner,
  BCard,
  BCardBody,
  BRow,
  BCol,
  BButton
} from "bootstrap-vue";

// Model display names
const MODEL_NAMES: Record<string, string> = {
  V0: "VORON 0",
  VT: "Trident",
  V2: "VORON 2",
  VS: "Switchwire",
  VL: "Legacy",
  VK: "MZBOT Kit",
  VPX: "Phoenix",
  VC: "Cascade"
};

@Component({
  head: {
    title: function() {
      return { inner: this.$options.name };
    }
  },
  components: {
    BSpinner,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton
  }
})
export default class Stats extends Vue {
  private serialCounters: Record<string, number> = {};
  private loading = true;
  private isExporting = false;

  private get displayCounters(): Record<string, number> {
    const counters: Record<string, number> = {};

    for (const [model, count] of Object.entries(this.serialCounters)) {
      // V1 in DB is actually VT (Trident)
      const displayName = model === "V1" ? "VT" : model;
      const label = MODEL_NAMES[displayName] || displayName;
      counters[label] = count;
    }

    // Sort by count descending
    return Object.fromEntries(
      Object.entries(counters).sort(([, a], [, b]) => b - a)
    );
  }

  private get total(): number {
    return Object.values(this.serialCounters).reduce((sum, count) => sum + count, 0);
  }

  private async exportDailyCSV() {
    this.isExporting = true;
    try {
      const response = await registryService.exportDailyCSV();
      this.downloadDailyCSV(response.data, "serial_daily_data.csv");
    } catch (error) {
      alert("An error occurred while exporting the CSV. Please try again.");
    } finally {
      this.isExporting = false;
    }
  }

  private downloadDailyCSV(data: Blob, filename: string) {
    const blob = new Blob([data], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(link.href);
  }

  private async loadSerialCounters() {
    this.loading = true;
    try {
      const counters = await registryService.getSerialCounters();
      this.serialCounters = counters as Record<string, number>;
    } catch (error) {
      console.error("Failed to load serial counters:", error);
    }
    this.loading = false;
  }

  created() {
    this.loadSerialCounters();
  }
}
